/* PATO-1 template interactions — ported from the mockup.
   Guarded so it only ever binds once, even if several PATO-1 sections
   each include the script. Queries the whole document, so section order
   does not matter. */
(function () {
  function init() {
    if (window.__pato1Init) return;
    window.__pato1Init = true;

    var bundles = Array.prototype.slice.call(document.querySelectorAll('.pato1-app .bundle'));
    var ctaPrice = document.getElementById('ctaPrice');
    var mainCta = document.getElementById('cta');
    var sticky = document.getElementById('stickyCta');
    var stickyBtn = document.getElementById('stickyBtn');
    var stickyName = document.getElementById('stickyName');
    var stickyPrice = document.getElementById('stickyPrice');
    var stickyWas = document.getElementById('stickyWas');

    // Los textos de interfaz vienen de Liquid (locales `cove.*`), asi que nada
    // de cara al cliente queda escrito en este archivo.
    var popularSuffix = (mainCta && mainCta.getAttribute('data-popular-suffix')) || '';

    // ---- direct-to-checkout ----
    // Se sustituye el carrito por el pack elegido con la Cart AJAX API y se
    // salta a /checkout, igual que en la plantilla US-1.
    var selBundle = null;
    var checkoutBusy = false;
    var cartBase = (mainCta && mainCta.getAttribute('data-cart-base')) || '/';
    if (cartBase.charAt(cartBase.length - 1) !== '/') { cartBase += '/'; }
    var jsonHeaders = { 'Content-Type': 'application/json' };

    // Prewarm (no bloqueante): saber si el carrito ya tiene articulos permite
    // ahorrarse la llamada extra a /cart/clear.js cuando esta vacio.
    var cartHasItems = null;
    fetch(cartBase + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartHasItems = !!(c && c.item_count > 0); })
      .catch(function () {});

    function setLoading(btn, on) {
      if (!btn) { return; }
      btn.classList.toggle('is-loading', on);
      if (on) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
      else { btn.removeAttribute('aria-busy'); btn.disabled = false; }
    }

    function goCheckout(btn) {
      if (checkoutBusy) { return; }
      if (!selBundle) { selBundle = document.querySelector('.pato1-app .bundle.on') || bundles[0]; }
      if (!selBundle) { return; }
      var variant = (selBundle.getAttribute('data-variant') || '').trim();
      if (!variant) {
        // Sin configurar: mejor fallar en consola que con una redireccion rota.
        if (window.console) { console.warn('[PATO-1] Este pack no tiene Variant ID; no se puede ir al checkout.'); }
        return;
      }
      var qty = parseInt(selBundle.getAttribute('data-qty'), 10);
      if (!qty || qty < 1) { qty = 1; }
      var item = { id: variant, quantity: qty };

      checkoutBusy = true;
      setLoading(btn, true);

      function add() {
        return fetch(cartBase + 'cart/add.js', {
          method: 'POST', headers: jsonHeaders, body: JSON.stringify({ items: [item] })
        });
      }
      var step = (cartHasItems === false)
        ? add()
        : fetch(cartBase + 'cart/clear.js', { method: 'POST', headers: jsonHeaders }).then(add);

      step
        .then(function (r) {
          if (!r.ok) { return r.text().then(function (t) { throw new Error(t); }); }
          // Se resuelve la URL final del checkout (con su token _r) y se navega
          // directamente: una sola entrada en el historial, asi el boton Atras
          // del navegador vuelve a ESTA ficha de producto.
          return fetch(cartBase + 'checkout', { redirect: 'follow' })
            .then(function (cr) {
              var u = cr && cr.url;
              window.location.href = (u && u.indexOf('/checkouts/') !== -1) ? u : (cartBase + 'checkout');
            })
            .catch(function () { window.location.href = cartBase + 'checkout'; });
        })
        .catch(function (err) {
          checkoutBusy = false;
          setLoading(btn, false);
          if (window.console) { console.error('[PATO-1] Checkout failed:', err); }
        });
    }

    // Al volver del checkout con el boton Atras la pagina puede restaurarse
    // desde la bfcache con el boton aun deshabilitado: se reinicia.
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) { return; }
      checkoutBusy = false;
      setLoading(document.getElementById('cta'), false);
      setLoading(document.getElementById('stickyBtn'), false);
      fetch(cartBase + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { cartHasItems = !!(c && c.item_count > 0); })
        .catch(function () {});
    });

    // ---- seleccion de pack + precios ----
    if (bundles.length) {
      selBundle = document.querySelector('.pato1-app .bundle.on') || bundles[0];

      function textOf(el) { return el ? el.textContent.trim() : ''; }

      function refresh() {
        var sel = document.querySelector('.pato1-app .bundle.on') || bundles[0];
        // El precio que se le promete al cliente es el impreso en la tarjeta del
        // pack, asi que es ese — y no otro calculo — el que va al boton.
        var now = textOf(sel.querySelector('.pn'));
        var was = textOf(sel.querySelector('.pw'));
        if (ctaPrice) { ctaPrice.textContent = now; }
        if (stickyPrice) { stickyPrice.textContent = now; }
        if (stickyWas) {
          stickyWas.textContent = was;
          stickyWas.hidden = was === '';
        }
        if (stickyName) {
          var nm = sel.getAttribute('data-name') || textOf(sel.querySelector('.nm'));
          var pop = sel.querySelector('.pop');
          stickyName.textContent = nm + (pop && popularSuffix ? ' · ' + popularSuffix : '');
        }
      }

      bundles.forEach(function (b) {
        b.addEventListener('click', function () {
          bundles.forEach(function (x) { x.classList.remove('on'); });
          b.classList.add('on');
          selBundle = b;
          refresh();
        });
      });

      if (mainCta) {
        mainCta.addEventListener('click', function (e) { e.preventDefault(); goCheckout(mainCta); });
      }

      // Ruidoso en consola cuando el precio de la tarjeta y el de la variante no
      // coinciden: al cliente se le cobra el de la variante, asi que siempre
      // significa que faltan por ajustar las variantes en Shopify.
      bundles.forEach(function (b) {
        var variantNow = parseInt(b.getAttribute('data-now-cents'), 10);
        var shown = Math.round(parseFloat(b.getAttribute('data-now')) * 100);
        if (isNaN(variantNow) || isNaN(shown) || variantNow === shown) { return; }
        if (window.console) {
          console.warn('[PATO-1] El pack "' + (b.getAttribute('data-name') || '') + '" muestra ' +
            (shown / 100) + ' pero la variante ' + b.getAttribute('data-variant') + ' cuesta ' +
            (variantNow / 100) + ' — el checkout cobrara el precio de la variante.');
        }
      });

      refresh();
    }

    // ---- visibilidad e interaccion de la barra fija ----
    var footerEl = document.querySelector('.rf-foot') || document.querySelector('.foot');
    var mainVisible = true, footerVisible = false;
    function updateSticky() {
      if (!sticky) return;
      var show = !mainVisible && !footerVisible;
      sticky.classList.toggle('on', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    if ('IntersectionObserver' in window && mainCta) {
      new IntersectionObserver(function (entries) {
        mainVisible = entries[0].isIntersecting;
        updateSticky();
      }, { threshold: 0.1 }).observe(mainCta);
      if (footerEl) {
        new IntersectionObserver(function (entries) {
          footerVisible = entries[0].isIntersecting;
          updateSticky();
        }, { threshold: 0.05 }).observe(footerEl);
      }
    }
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) { e.preventDefault(); goCheckout(stickyBtn); });
    }

    // ---- galeria: miniaturas + arrastre ----
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('#thumbs .thumb'));
    var mainWrap = document.getElementById('mainImg');
    var mainTag = document.querySelector('#mainImg .tag');
    var mainPic = document.querySelector('#mainImg img');
    var thumbsRow = document.getElementById('thumbs');
    var reviewBadge = document.querySelector('#mainImg .gm-rvcard');
    var fulls = thumbs.map(function (t) { return t.getAttribute('data-full'); });

    // La tarjeta de resena solo acompana a la primera foto: en las demas
    // taparia justo lo que el cliente ha ido a mirar.
    function paintBadge(i) {
      if (reviewBadge) { reviewBadge.style.display = (i === 0) ? '' : 'none'; }
    }

    // Se precargan todas las fotos grandes para que el cambio sea instantaneo.
    var fullCache = {};
    fulls.forEach(function (f) {
      if (f && !fullCache[f]) {
        var pre = new Image();
        pre.decoding = 'async';
        pre.src = f;
        fullCache[f] = pre;
      }
    });
    if (mainPic) { mainPic.decoding = 'async'; }

    function labelOf(i) { return thumbs[i] ? thumbs[i].getAttribute('data-label') : null; }

    function markThumb(i) {
      thumbs.forEach(function (x) { x.classList.remove('on'); });
      if (thumbs[i]) { thumbs[i].classList.add('on'); }
      var lbl = labelOf(i);
      if (mainTag && lbl) { mainTag.textContent = lbl; }
      if (thumbsRow && thumbs[i] && thumbsRow.scrollWidth > thumbsRow.clientWidth) {
        var t = thumbs[i];
        var left = t.offsetLeft - (thumbsRow.clientWidth - t.offsetWidth) / 2;
        if (thumbsRow.scrollTo) { thumbsRow.scrollTo({ left: Math.max(0, left), behavior: 'smooth' }); }
        else { thumbsRow.scrollLeft = Math.max(0, left); }
      }
    }

    function swapMain(full) {
      if (!mainPic || !full || mainPic.getAttribute('src') === full) { return; }
      var pre = fullCache[full] || new Image();
      if (!fullCache[full]) { fullCache[full] = pre; pre.src = full; }
      var apply = function () {
        mainPic.src = full;
        mainPic.style.opacity = '0.55';
        requestAnimationFrame(function () { mainPic.style.opacity = '1'; });
      };
      if (pre.decode) { pre.decode().then(apply).catch(apply); }
      else if (pre.complete) { apply(); }
      else { pre.onload = apply; }
    }

    var canSlide = !!mainWrap && !!mainPic && fulls.length > 1 &&
                   fulls.every(function (f) { return !!f; });

    if (!canSlide) {
      // Una sola foto (o miniaturas sin foto grande): comportamiento de siempre.
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          markThumb(i);
          if (fulls[i]) { swapMain(fulls[i]); }
          paintBadge(i);
        });
      });
    } else {
      var ANIM = 320;
      var idx = Math.max(0, thumbs.indexOf(document.querySelector('#thumbs .thumb.on')));
      var track = document.createElement('div');
      track.className = 'gm-track';

      fulls.forEach(function (src, i) {
        var slide = document.createElement('div');
        slide.className = 'gm-slide';
        if (i === idx) {
          // se mueve la <img> ya pintada, no se crea otra
          slide.appendChild(mainPic);
        } else {
          var im = document.createElement('img');
          im.decoding = 'async';
          im.alt = mainPic.getAttribute('alt') || '';
          im.src = src;
          slide.appendChild(im);
        }
        track.appendChild(slide);
      });
      mainWrap.insertBefore(track, mainWrap.firstChild);

      var settleTimer = null;
      function width() { return mainWrap.clientWidth || 1; }
      function settle() {
        mainWrap.classList.remove('gm-sliding');
        paintBadge(idx);
      }
      function place(px, anim) {
        if (anim) { track.classList.add('gm-anim'); } else { track.classList.remove('gm-anim'); }
        track.style.transform = 'translate3d(' + px + 'px,0,0)';
      }
      function goTo(i, anim) {
        idx = Math.max(0, Math.min(fulls.length - 1, i));
        place(-idx * width(), anim !== false);
        markThumb(idx);
        if (settleTimer) { clearTimeout(settleTimer); }
        if (anim === false) { settle(); }
        else { settleTimer = setTimeout(settle, ANIM + 10); }
      }

      place(-idx * width(), false);
      paintBadge(idx);
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });

      // ---- arrastre (dedo, raton o lapiz) ----
      var down = false, decided = false, horiz = false, moved = false;
      var startX = 0, startY = 0, dx = 0, w = 0;

      function onDown(e) {
        if (e.pointerType === 'mouse' && e.button !== 0) { return; }
        down = true; decided = false; horiz = false; moved = false;
        startX = e.clientX; startY = e.clientY; dx = 0; w = width();
        if (settleTimer) { clearTimeout(settleTimer); }
        track.classList.remove('gm-anim');
      }
      function onMove(e) {
        if (!down) { return; }
        dx = e.clientX - startX;
        var dy = e.clientY - startY;
        if (!decided) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) { return; }
          decided = true;
          horiz = Math.abs(dx) > Math.abs(dy);
          if (!horiz) { down = false; return; }   // scroll vertical: no es lo nuestro
          mainWrap.classList.add('gm-sliding');
          if (mainWrap.setPointerCapture) {
            try { mainWrap.setPointerCapture(e.pointerId); } catch (err) {}
          }
        }
        moved = true;
        var off = dx;
        // resistencia en los extremos, para que se note el tope
        if ((idx === 0 && dx > 0) || (idx === fulls.length - 1 && dx < 0)) { off = dx * 0.32; }
        place(-idx * w + off, false);
      }
      function onUp() {
        if (!down) { return; }
        down = false;
        if (!horiz) { return; }
        var limit = Math.max(38, w * 0.15);
        if (dx <= -limit) { goTo(idx + 1); }
        else if (dx >= limit) { goTo(idx - 1); }
        else { goTo(idx); }
      }

      if (window.PointerEvent) {
        mainWrap.addEventListener('pointerdown', onDown);
        mainWrap.addEventListener('pointermove', onMove);
        mainWrap.addEventListener('pointerup', onUp);
        mainWrap.addEventListener('pointercancel', onUp);
      } else {
        mainWrap.addEventListener('touchstart', function (e) { onDown(e.touches[0]); }, { passive: true });
        mainWrap.addEventListener('touchmove', function (e) { onMove(e.touches[0]); }, { passive: true });
        mainWrap.addEventListener('touchend', onUp);
        mainWrap.addEventListener('touchcancel', onUp);
      }

      mainWrap.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);

      // al girar el movil o cambiar de breakpoint, se recoloca sin animar
      var rt = null;
      window.addEventListener('resize', function () {
        if (rt) { clearTimeout(rt); }
        rt = setTimeout(function () { place(-idx * width(), false); }, 120);
      });
    }

    // ---- videos: autoplay en silencio, sin interfaz ----
    // El silencio se re-fuerza desde JS porque algunos navegadores restauran el
    // volumen al re-adjuntar el elemento, y un video con sonido no puede
    // autoreproducirse (lo bloquean) ademas de sonar sin permiso.
    // Todos los .vmedia de la pagina: la rejilla UGC y los recuadros de los
    // bloques de contenido comparten exactamente el mismo trato.
    var ugcVideos = Array.prototype.slice.call(document.querySelectorAll('.pato1-app .vmedia'));
    if (ugcVideos.length) {
      var silence = function (v) {
        v.muted = true;
        v.defaultMuted = true;
        v.volume = 0;
        v.controls = false;
      };
      var kick = function (v) {
        silence(v);
        var p = v.play();
        if (p && typeof p.catch === 'function') { p.catch(function () {}); }
      };
      ugcVideos.forEach(function (v) {
        silence(v);
        v.addEventListener('loadedmetadata', function () { kick(v); });
        v.addEventListener('canplay', function () { kick(v); });
        // Si algo (una extension, el sistema) le devuelve el volumen, se corrige.
        v.addEventListener('volumechange', function () {
          if (!v.muted || v.volume !== 0) { silence(v); }
        });
        kick(v);
      });

      // Solo se reproducen mientras se ven: tres clips en bucle todo el rato
      // calientan el movil y gastan datos sin que nadie los mire.
      if ('IntersectionObserver' in window) {
        var vio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            e.target.inView = e.isIntersecting;
            if (e.isIntersecting) { kick(e.target); }
            else if (!e.target.paused) { e.target.pause(); }
          });
        }, { threshold: 0.1 });
        ugcVideos.forEach(function (v) { vio.observe(v); });
      }

      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState !== 'visible') { return; }
        ugcVideos.forEach(function (v) { if (v.inView !== false && v.paused) { kick(v); } });
      });
    }

    // ---- CTA intermedios: bajan al bloque de compra ----
    document.addEventListener('click', function (e) {
      var el = e.target.closest && e.target.closest('.pato1-app [data-scroll-to-cta]');
      if (!el) { return; }
      e.preventDefault();
      var target = document.getElementById('cta');
      if (target) { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });

    // ---- se desactiva el zoom por pellizco / doble toque en la ficha ----
    document.addEventListener('gesturestart', function (e) { e.preventDefault(); }, { passive: false });
    document.addEventListener('gesturechange', function (e) { e.preventDefault(); }, { passive: false });
    var lastTouchEnd = 0;
    document.addEventListener('touchend', function (e) {
      var now = Date.now();
      if (now - lastTouchEnd <= 300) { e.preventDefault(); }
      lastTouchEnd = now;
    }, { passive: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
